import { PropsWithChildren, ReactNode, useState } from 'react'
import styled from 'styled-components'
import {
  Box,
  Text,
  IconChevronUp,
  IconChevronDown,
  ResponsiveRender
} from '@machobear/design-system'
import { vars } from '@machobear/design-system/css'

const Container = styled.div`
  position: relative;
`

interface ButtonConfig {
  border: string
  background: string
  hover: string
}

// TODO: Tried using DS Button component, but couldn't get it to render 2icons correctly
// plus DS button doesn't support required colours. Spoke with Otavio about this issue,
// decided to use a bespoke compoment for now.
const Button = styled.div<ButtonConfig>`
  height: 44px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 8px 8px 8px 12px;
  background-color: ${({ background }) => background};
  border: 1px ${({ border }) => border} solid;
  border-radius: 4px;

  &:hover {
    filter: brightness(95%);
  }
`

const buttonColors: any = {
  formAccent: {
    border: vars.borderColor.formAccent,
    background: vars.backgroundColor.formAccent
  },
  caution: {
    border: vars.borderColor.caution,
    background: vars.backgroundColor.cautionLight
  },
  positive: {
    border: vars.borderColor.positive,
    background: vars.backgroundColor.positiveLight
  }
}

const textTone: any = {
  formAccent: 'neutralInverted',
  caution: 'caution',
  positive: 'positive'
}

interface Props extends PropsWithChildren {
  icon?: ReactNode
  tone?: 'caution' | 'positive' | 'formAccent'
  label: string
}

export const DropdownButton = ({ icon = null, tone = 'formAccent', label, children }: Props) => {
  const [open, setOpen] = useState(false)

  return (
    <Container>
      <Button
        {...buttonColors[tone]}
        onClick={() => setOpen(!open)}
        data-testid="listing-state-button"
      >
        {icon}
        <Text weight="strong" tone={textTone[tone]}>
          {label}
        </Text>

        {open ? (
          <IconChevronUp size="xsmall" tone={textTone[tone]} />
        ) : (
          <IconChevronDown size="xsmall" tone={textTone[tone]} />
        )}
      </Button>

      {open && (
        <>
          <ResponsiveRender above="tablet">
            <Box
              border="borderNeutralLight"
              borderRadius="large"
              boxShadow="large"
              background="body"
              padding="gutter"
              display="flex"
              flexDirection="row"
              justifyContent="spaceBetween"
              style={{
                position: 'absolute',
                top: '56px',
                width: '400px',
                right: '-2px',
                zIndex: 105
              }}
              alignItems="center"
              data-testid="listing-state-dropdown"
            >
              {children}
            </Box>
          </ResponsiveRender>

          <ResponsiveRender below="desktop">
            <Box
              border="borderNeutralLight"
              borderRadius="large"
              boxShadow="large"
              background="body"
              padding="gutter"
              display="flex"
              flexDirection="row"
              justifyContent="spaceBetween"
              style={{
                position: 'absolute',
                top: '56px',
                width: '300px',
                left: '0',
                zIndex: 105
              }}
              alignItems="center"
              data-testid="listing-state-dropdown"
            >
              {children}
            </Box>
          </ResponsiveRender>
        </>
      )}
    </Container>
  )
}
